export type { AppRuntime } from './runtimeContext';
import type { ReactNode } from 'react';
import { RuntimeContext, type AppRuntime } from './runtimeContext';

export function RuntimeProvider({
  runtime,
  children,
}: {
  runtime: AppRuntime;
  children: ReactNode;
}) {
  return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
}
